/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = '/user-profile-api';
}

/**
 * Parameters for `UserProfileApiModule.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
